// AbsolutePink typography — see .claude/DESIGN.md.
//   Display:  Fraunces (variable, optical sizing) — heritage-manual serif
//   Body/UI:  Source Sans 3 — humanist sans, long-form readability
//   Mono:     IBM Plex Mono — mid-century technical-print feel
export const F = {
  display: "'Fraunces', Georgia, 'Times New Roman', serif",
  body: "'Source Sans 3', 'Helvetica Neue', Arial, sans-serif",
  mono: "'IBM Plex Mono', 'JetBrains Mono', Menlo, monospace",
} as const;

export const FONT_LOADER_HREF =
  'https://fonts.googleapis.com/css2?' +
  'family=Fraunces:opsz,wght@9..144,400;9..144,500;9..144,600;9..144,700&' +
  'family=Source+Sans+3:wght@400;500;600;700&' +
  'family=IBM+Plex+Mono:wght@400;500;600&' +
  'display=swap';
